module Meevo.Plugins.Transworld {
    'use strict';

    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    interface IAresForShowIcons {
        id: number;
        displayName: string;
    };

    export class MainSection extends TransworldBaseSection {

        constructor(
            params: ISectionParamsTransworld,
            protected modalService: Meevo.Components.Modal.IModalService
        ) {
            super(params);
        }

        public model: ITranswolrdSettings;
        private listMoverConfig = {
            allSelected: false,
            useAllItemsAsSelected: true,
            isSelectAllCheckboxHidden: true,
            fullResponse: true,
            generic: true,
            hideTitles: true
        };

        saveData(): void {
            this.preSave();
            this.context.usageTrackingLog(Meevo.Model.VerbEnum.SaveButtonClicked, null);

            if (this.originalEntity.enableTransworld && !this.model.enableTransworld) {
                this.modalService.confirm('TEXT_TRANSWORLD_CONFIRM_UNCHECKED', Meevo.Components.Modal.ModalTranslationModes.Translate).then((result) => {
                    if (result) {
                        this.updateTransworldSettings();
                    }
                });
            } else {
                this.updateTransworldSettings();
            }
        }        

        updateTransworldSettings(): void {
            this.loadingInProgress = true;

            this.transworldService.updateSettings(this.model).then((settings: ITranswolrdSettings) => {
                this.model = settings;
                this.activate();
                this.context.setMode(Meevo.Model.MaintenanceFormState.Readonly);
                this.loggingService.trace(`Updates saved.`);
                this.modalService.alert('TEXT_TRANSWORLD_SETTING_SAVE', Meevo.Components.Modal.ModalTranslationModes.Translate);
            }).finally(() => {
                this.loadingInProgress = false;
                this.context.postUpdate(this.model);
            });
        }

        get securityAccessEnum(): any {
            return SecurityAccessEnum;
        }
    }
}
